export const NO_AVAILABLE_RESULTS = [
  {
    label: 'No available results',
    value: null,
    disabled: true
  }
];